<template>
  <div id="pivo-auth-reset-pw">
    <!--- <img src="https://app.youvr.io/assets/images/logos/youvr-logo-01.png"> -->
    <img src="/logo.webp">

    <h2>Reset Password</h2>
    <div class="form-card">
      <Form :model="resetData" :rules="validationRules" ref="form">
        <FormItem prop="password">
          <Poptip trigger="focus" class="password-guide" :placement="placement" width="220">
            <Input v-model="resetData.password" class="inputs"
              type="password" :placeholder="$t('register.passwordPlaceholder')"
              @on-enter="recoverPassword('form')"/>
            <div slot="content">
              <ul class="password-strength-list">
                <p><Icon type="ios-key" /> Password must</p>
                <li v-for="filter in checker.filters" :key="filter.message"
                    :class="{'passed':(filter.func(resetData.password))}">
                  <Badge :status="filter.func(resetData.password) ?
                  'success':'error'"/>
                  {{ filter.message }}
                </li>
              </ul>
            </div>
          </Poptip>
        </FormItem>
        <FormItem prop="confirm">
          <Input v-model="resetData.confirm" class="inputs"
            type="password" :placeholder="$t('register.confirmPlaceholder')"
            @on-enter="recoverPassword('form')"/>
        </FormItem>
        <FormItem>
          <Button @click="recoverPassword('form')"
            id='recover-btn' v-t="'resetPassword.reset'" :loading="loading">
          </Button>
        </FormItem>
      </Form>
    </div>
  </div>
</template>

<script>
import api2 from '../../api';
import { checker } from '../../libs/validations';

export default {
  props: ['code'],

  data() {
    const validatePassword = (rule, val, cb) => {
      const p2 = this.resetData.confirm;
      if (val === '' || val.replace(/\s/gi, '') === '') {
        cb(new Error(this.$t('common.errors.empty', { field: 'Password' })));
      } else if (val.length < 6) {
        cb(new Error(this.$t('common.errors.min', { field: 'Password', length: 6 })));
      } else if (p2 && this.resetData.confirm !== p2) {
        cb(new Error(this.$t('common.errors.confirm')));
      } else if (!this.checker.passed(val)) {
        cb(new Error(this.$t('common.errors.strength')));
      } else {
        /* before this more password validation rules should be added */
        cb();
      }
      return true;
    };

    const validateConfirm = (rule, val, cb) => {
      if (val === '') {
        cb(new Error(this.$t('common.errors.empty', { field: 'Confirm Password' })));
      } else if (val !== this.resetData.password) {
        cb(new Error(this.$t('common.errors.confirm')));
      } else {
        cb();
      }
      return true;
    };

    return {
      loading: false,
      resetData: {
        password: '',
        confirm: ''
      },
      checker,
      validationRules: {
        password: [
          {
            required: true,
            validator: validatePassword,
            trigger: 'blur',
            whitespace: true
          }
        ],
        confirm: [
          {
            required: true,
            validator: validateConfirm,
            trigger: 'blur',
            whitespace: true
          }
        ]
      }
    };
  },

  computed: {
    placement() {
      return window.innerWidth > 800 ? 'right' : 'top';
    }
  },

  methods: {
    recoverPassword(name) {
      /* eslint-disable max-len */
      const payload = `code=${this.code}&password=${this.resetData.password}&passwordConfirmation=${this.resetData.confirm}`;
      /* eslint-enable max-len */
      this.loading = true;
      this.$refs[name].validate(async (valid) => {
        try {
          if (valid) {
            const resp = await api2.resetPassword(payload);
            if (resp) {
              this.$Message.info(this.$t('common.state.success', {
                action: 'reset',
                object: 'password'
              }));
              this.$router.push({
                name: 'login'
              });
            } else {
              throw new Error(this.$t('common.state.fail', {
                action: 'reset',
                object: 'password'
              }));
            }
          } else {
            throw new Error(this.$t('common.errors.invalid'));
          }
        } catch (e) {
          this.$Message.error(e.message);
        }
      });
      this.loading = false;
    }
  }
};
</script>

<style lang="less">
@import '../../styles/index.less';

#pivo-auth-reset-pw {
  padding-bottom: 25px;
  text-align: center;
  background-color: hsla(0, 0%, 20%, 0.5);
  border-radius: 5px;
  color: white;

  img {
    margin-top: 30px;
    margin-bottom: 20px;
  }

  .form-card {
    width: 300px;
    max-width: 80%;
    margin: 0 auto;
    margin-top: 30px;

    #recover-btn {
      color: white;
      background-color: #DF0F4F;
      border-color: #DF0F4F;
    }

    .password-guide {
      width: 100%;

      .ivu-poptip-rel {
        width: 100%;
      }

      .password-strength-list {
        text-align: left;

        & > p {
          font-size: 1.2em;
          color: #4a4a4a;
        }

        & > li {
          padding: 3px;
          font-size: 1em;
          color: @third-color;
          transition: 0.5s color ease;

          &.passed {
            color: @font-gray1;
          }
        }
      }
    }
  }
}
</style>
